module.exports = __webpack_public_path__ + "static/media/logo04.5eeea070.svg";